
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    path: {
      type: String,
      'default': () => (''),
    }
  },
})
